
/**
 * Generates a mock funnel strategy when the backend is unavailable.
 * This ensures the UI remains functional for demonstration and testing purposes.
 *
 * @param {string} goal - The user's primary goal (e.g. "Generate Leads")
 * @param {string} industry - The target industry (e.g. "SaaS")
 * @returns {object} - A funnel object compatible with FunnelMap
 */
export const generateMockFunnel = (goal, industry) => {
    return {
      name: `${industry} Growth Funnel (Simulation)`,
      description: `A strategic funnel designed to ${goal.toLowerCase()} in the ${industry} sector. Optimized for high conversion in the current market climate.`,
      steps: [
        { id: "1", type: "traffic", label: "Paid Social Ads", description: `Targeted ads on LinkedIn and Facebook focusing on ${industry} pain points.` },
        { id: "2", type: "landing", label: "High-Value Landing Page", description: "Headline-driven page capturing intent with a strong lead magnet." },
        { id: "3", type: "email", label: "Nurture Sequence", description: "3-part email series to build authority and trust." },
        { id: "4", type: "sales", label: "Conversion Mechanism", description: "Direct call to action aligned with your primary goal." },
        { id: "5", type: "thankyou", label: "Onboarding & Upsell", description: "Immediate value delivery and next-step guidance." }
      ],
      edges: [
        { from: "1", label: "Click" },
        { from: "2", label: "Opt-in" },
        { from: "3", label: "Engage" },
        { from: "4", label: "Convert" }
      ],
      metrics: [
         { metric: "Est. CPC", benchmark: "$2.50" },
         { metric: "Conv. Rate", benchmark: "3.2%" },
         { metric: "Est. ROAS", benchmark: "4.1x" }
      ],
      tips: [
          `Focus on strong visual hooks in the ad layer specific to ${industry}.`,
          "Ensure the landing page load speed is under 2s for mobile users.",
          "Personalize email subject lines to increase open rates by up to 20%."
      ]
    };
  };
